import React from 'react';
import { graphql } from 'gatsby';
import PropTypes from 'prop-types';

import ArticleContent from '../../partials/chaos-monkey/ArticleContent';

const ChaosMonkeySingle = ({ data, pageContext }) => (
  <ArticleContent data={data} pageContext={pageContext} />
);

ChaosMonkeySingle.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
};

export default ChaosMonkeySingle;

export const pageQuery = graphql`
  query ChaosMonkeySingle($slug: String!) {
    article: markdownRemark(
      fields: { slug: { eq: $slug } }
      fileAbsolutePath: { regex: "/src/chaos-monkey/" }
    ) {
      ...ChaosMonkeySingleFragment
    }
  }
`;
